export default __webpack_public_path__ + "static/media/usyd-logo2.a047dc34.svg";